import { takeLatest, call, put } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'
import { errorHandler } from '../../CandidateExperience/helpers/errorHelpers'
import { fetchJobPreferenceEntitySaga, updateJobPreferenceEntitySaga } from '../../CandidateExperience/sagas/jobPreferences'
import { fetchStaticCountryEntitiesSaga } from '../../CandidateExperience/sagas/staticCountries'
import * as employmentPreferencesView from '../reducks/employmentPreferences'

export function* fetchJobPreferenceSaga({ meta }) {
  try {
    const response = yield call(fetchJobPreferenceEntitySaga, meta.id)
    yield put(employmentPreferencesView.fetchJobPreferenceSuccess(meta.id, response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(employmentPreferencesView.fetchJobPreferenceError(meta.id, error))
  }
}

export function* updateJobPreferenceSaga({ meta }) {
  try {
    const response = yield call(updateJobPreferenceEntitySaga, meta.id, meta.data)
    yield put(employmentPreferencesView.updateJobPreferenceSuccess(meta.id, response))
    yield call(meta.resolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(employmentPreferencesView.updateJobPreferenceError(meta.id, error))
    yield call(meta.reject, new SubmissionError({ _error: error }))
  }
}

export function* fetchStaticCountriesSaga() {
  try {
    const response = yield call(fetchStaticCountryEntitiesSaga)
    yield put(employmentPreferencesView.fetchStaticCountriesSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(employmentPreferencesView.fetchStaticCountriesError(error))
  }
}

export default function* watchEmploymentSaga() {
  yield takeLatest(employmentPreferencesView.FETCH_JOB_PREFERENCE, fetchJobPreferenceSaga)
  yield takeLatest(employmentPreferencesView.UPDATE_JOB_PREFERENCE, updateJobPreferenceSaga)
  yield takeLatest(employmentPreferencesView.FETCH_STATIC_COUNTRIES, fetchStaticCountriesSaga)
}
